import { isDatePassedDateOnly } from '@shared/libs/date-validation';

export const INVITATION_RESEND_BLOCKED_MESSAGE =
  'При повторной отправке для редактирования доступны только тип отправки, тема письма и текст приглашения';

export type RepeatSendFlowState = {
  isRepeatSending: boolean;
  isInvitationDatePassed: boolean;
  isTicketSendDatePassed: boolean;
  isInvitationSettingsLocked: boolean;
  isTicketSectionLocked: boolean;
  isInvitationResendBlocked: boolean;
  isPrimaryLikeInvitationFlow: boolean;
};

export const evaluateRepeatSendFlow = ({
  totalInvites,
  invitationExpiresAt,
  sendTicketAfterAcceptAt,
  inviteSentAt,
}: {
  totalInvites: number;
  invitationExpiresAt: string | null | undefined;
  sendTicketAfterAcceptAt: string | null | undefined;
  inviteSentAt?: string | null;
}): RepeatSendFlowState => {
  const isRepeatSending = totalInvites > 0 || Boolean(inviteSentAt);

  if (!isRepeatSending) {
    return {
      isRepeatSending: false,
      isInvitationDatePassed: false,
      isTicketSendDatePassed: false,
      isInvitationSettingsLocked: false,
      isTicketSectionLocked: false,
      isInvitationResendBlocked: false,
      isPrimaryLikeInvitationFlow: false,
    };
  }

  const isInvitationDatePassed = isDatePassedDateOnly(invitationExpiresAt);
  const isTicketSendDatePassed = isDatePassedDateOnly(sendTicketAfterAcceptAt);

  if (isInvitationDatePassed) {
    return {
      isRepeatSending: false,
      isInvitationDatePassed: true,
      isTicketSendDatePassed,
      isInvitationSettingsLocked: false,
      isTicketSectionLocked: false,
      isInvitationResendBlocked: false,
      isPrimaryLikeInvitationFlow: true,
    };
  }

  return {
    isRepeatSending,
    isInvitationDatePassed,
    isTicketSendDatePassed,
    isInvitationSettingsLocked: true,
    isTicketSectionLocked: true,
    isInvitationResendBlocked: false,
    isPrimaryLikeInvitationFlow: false,
  };
};
